export const EXISTING_PROJECT_LIST = "EXISTING_PROJECT_LIST";
export const CREATE_PRE_SALE_SUPPLY = "CREATE_PRE_SALE_SUPPLY";
export const CLIENT_LIST = "CLIENT_LIST";
export const GET_SOLUTION = "GET_SOLUTION";
export const GET_ALL_QUOTATIONS = "GET_ALL_QUOTATIONS";
export const GET_QUOTATION = "GET_QUOTATION";
export const QUOTATION_HISTORY = "QUOTATION_HISTORY";
